import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const Business: AppRouteModule = {
  path: '/outInWarehouse',
  name: 'OutInWarehouse',
  identify: 'outInWarehouse',
  component: LAYOUT,
  redirect: '/outInWarehouse/inWarehouse',
  meta: {
    icon: 'streamline:shipping-transfer-cart-package-box-fulfillment-cart-warehouse-shipping-delivery',
    title: '出入库管理',
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    {
      path: 'inWarehouse',
      name: 'InWarehouse',
      identify: 'inWarehouse',
      component: () => import('@/views/outInWarehouse/inWarehouse/index.vue'),
      meta: {
        title: '入库管理',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'outWarehouse',
      name: 'OutWarehouse',
      identify: 'outWarehouse',
      component: () => import('@/views/outInWarehouse/outWarehouse/index.vue'),
      meta: {
        title: '出库管理',
      },
    },
  ],
};

export default Business;
